<template>
  <button
    type="button"
    class="listing--action-btn recommended-listing-action"
    @click="clickHandler"
  >
    <div class="btn--icon">
      <img src="@/assets/img/icons/spotlight-sundul.png" />
    </div>
    <div class="recommended-listing-action--content">
      <div class="top--text">
        {{ `${$t('general.btn.recommendedListing')}` }}
      </div>
      <div class="bottom--text recommended-price">
        <span class="recommended-price--current">{{ `25 ${$t('general.coin')}` }}</span>
        <span class="recommended-price--original">{{ `50 ${$t('general.coin')}` }}</span>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'schedule-repost-btn',
  props: {
    listingUuid: {
      type: String,
      required: true,
    },
  },
  components: {},
  computed: {},
  methods: {
    async setRecommendedListing() {
      console.log('AYO SET RECOMMENDED LISTING!', this.listingUuid);
      try {
        const success = await this.$store.dispatch('recommendedListing/purchase', this.listingUuid);
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.recommendedListing.success'),
            'success',
          );
          this.$emit('actionDone', 'recommendedListing');
        }
      } catch (e) {
        console.log('ERROR SET RECOMMENDED LISTING: ', e);
      }
    },
    clickHandler() {
      this.$modal.show('recommended-listing-modal', {
        submitAction: this.setRecommendedListing,
        listingUuid: this.listingUuid,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/utils/variables';

.recommended-listing-action {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  min-width: 218px;

  border: 1px solid rgba(127, 18, 24, 0.18);
  border-radius: 999px;

  background: linear-gradient(135deg, #c91b23 0%, #b4171f 52%, #9d141b 100%);

  box-shadow: 0 8px 20px rgba(116, 15, 21, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.16);

  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.recommended-listing-action::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  width: 65%;
  height: 100%;

  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0.13) 0%,
    rgba(255, 255, 255, 0.04) 48%,
    transparent 100%
  );

  pointer-events: none;
}

.recommended-listing-action::after {
  content: '';
  position: absolute;
  right: -26px;
  bottom: -36px;
  z-index: -1;

  width: 92px;
  height: 92px;

  border: 18px solid rgba(255, 255, 255, 0.045);
  border-radius: 50%;

  pointer-events: none;
}

.recommended-listing-action:hover {
  filter: saturate(1.02);
  transform: translateY(-1px);

  box-shadow: 0 11px 25px rgba(116, 15, 21, 0.21), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.recommended-listing-action:active {
  filter: none;
  transform: translateY(0);

  box-shadow: 0 6px 16px rgba(116, 15, 21, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.14);
}

.recommended-listing-action:focus {
  outline: none;
}

.recommended-listing-action:focus-visible {
  box-shadow: 0 0 0 3px rgba(201, 27, 35, 0.17), 0 10px 24px rgba(116, 15, 21, 0.2);
}

.recommended-listing-action .btn--icon {
  display: inline-flex;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;

  border: 1px solid rgba(255, 255, 255, 0.74);
  border-radius: 999px;

  color: #c81919;
  background: #ffffff;

  box-shadow: 0 5px 12px rgba(77, 9, 14, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.recommended-listing-action .btn--icon img {
  opacity: 1;

  /* Mengubah icon putih menjadi merah brand */
  filter: brightness(0) saturate(100%) invert(15%) sepia(88%) saturate(4635%) hue-rotate(352deg)
    brightness(91%) contrast(97%);
}

.recommended-listing-action .btn--icon svg {
  color: inherit;
  fill: currentColor;
}

.recommended-listing-action .btn--icon .v-icon {
  color: #c81919;
}

.recommended-listing-action--content {
  min-width: 0;
  text-align: left;
}

.recommended-listing-action .top--text {
  overflow: hidden;

  color: #ffffff;
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: $font-sm;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recommended-listing-action .bottom--text {
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.78);
}

.recommended-price {
  display: flex;
  align-items: center;
  gap: 7px;
}

.recommended-price--current {
  color: #ffffff;
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: $font-sm;
  line-height: 1.3;
}

.recommended-price--original {
  color: rgba(255, 255, 255, 0.54);
  font-family: Poppins-Regular, Poppins, sans-serif;
  font-size: $font-xs;
  line-height: 1.3;

  text-decoration: line-through;
  text-decoration-color: rgba(255, 255, 255, 0.55);
  text-decoration-thickness: 1px;
}

@media #{$phones} {
  .recommended-listing-action {
    width: 100%;
    min-width: 0;
    border-radius: 14px;
  }

  .recommended-listing-action .btn--icon {
    flex-basis: 30px;
    border-radius: 8px;
  }

  .recommended-listing-action .top--text,
  .recommended-price--current {
    font-size: 12px;
  }
}
</style>
